import type {
  DropdownFormFieldProps,
  FormFieldComponents,
} from '@zealth/core/formFields/types'

import { BirthdayFormField } from './BirthdayFormField'
import { CategoryFormField } from './CategoryFormField'
import { CheckboxFormField } from './CheckboxFormField'
import { DateFormField } from './DateFormField'
import { DropdownFormField } from './DropdownFormField'
import { MoneyFormField } from './MoneyFormField'
import { MoneyWithPeriodFormField } from './MoneyWithPeriodFormField'
import { NumberDropdownFormField } from './NumberDropdownFormField'
import { NumberFormField } from './NumberFormField'
import { OwnershipFormField } from './OwnershipFormField'
import { PercentageFormField } from './PercentageFormField'
import { SegmentedControlFormField } from './SegmentedControlFormField'
import { SwitchFormField } from './SwitchFormField'
import { TextFormField } from './TextFormField'
import { withInfo } from './withInfo'
import { ZipCodeFormField } from './ZipCodeFormField'

// Every field is wrapped with `withInfo`, which renders an InfoPopover beside
// the control when the question carries `info` and is a no-op otherwise. Fields
// that never receive `info` (Birthday, Ownership, SegmentedControl,
// NumberDropdown) are wrapped too, so the registry stays uniform.
export const portalFormFields: FormFieldComponents = {
  BirthdayFormField: withInfo(BirthdayFormField),
  CategoryFormField: withInfo(CategoryFormField),
  CheckboxFormField: withInfo(CheckboxFormField),
  DateFormField: withInfo(DateFormField),
  DropdownFormField: withInfo<DropdownFormFieldProps>(DropdownFormField),
  MoneyFormField: withInfo(MoneyFormField),
  MoneyWithPeriodFormField: withInfo(MoneyWithPeriodFormField),
  NumberDropdownFormField: withInfo(NumberDropdownFormField),
  NumberFormField: withInfo(NumberFormField),
  OwnershipFormField: withInfo(OwnershipFormField),
  PercentageFormField: withInfo(PercentageFormField),
  SegmentedControlFormField: withInfo(SegmentedControlFormField),
  SwitchFormField: withInfo(SwitchFormField),
  TextFormField: withInfo(TextFormField),
  ZipCodeFormField: withInfo(ZipCodeFormField),
}
